import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageCover, CoverButton } from '@/components/Page';

// Rota sem match dentro do Layout (usuário logado): só a capa, com o caminho de volta.
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <PageCover
      title="Página não encontrada"
      subtitle="O endereço acessado não existe ou foi movido."
      actions={
        <CoverButton primary onClick={() => navigate('/')}>
          <ArrowLeft /> Voltar ao início
        </CoverButton>
      }
    />
  );
};

export default NotFound;
